import { getMailboxInfo } from 'owa-mail-mailboxinfo';
//TODO: 22724 itemId should be ClientItemId so we don't need this function to getMailboxInfo
export function getItemClientId(item, tableView) {
    return { Id: item.ItemId.Id, mailboxInfo: getMailboxInfo(tableView) };
}
export default function mapItemTypeToItemRelation(item, tableView) {
    return {
        executeSearchSortOrder: item.SortOrderSource,
        clientId: getItemClientId(item, tableView),
        instanceKey: item.InstanceKey,
    };
}
//# sourceMappingURL=mapItemTypeToItemRelation.js.map